const { createContext } = require("react");

export const ReceiveEmailContext = createContext()
